<template>
    <dir style="overflow-x: auto;padding: 0;margin: 0;margin-top: 15px">
        <div style="display: flex;flex-direction: row">
            
            <div v-for="(messages, mindex) in intentItems" :key="'intent_message_'+mindex" style="flex-grow: 1; min-width: 300px;max-width: 300px;overflow-x: hidden;padding-bottom: 15px" :style="{'border-right': hasAlternative ? '1px dashed #eee' : '0px'}">
                <ul style="margin: 0;padding: 0;">
                    <div class="row" style="border-bottom: 1px solid #eee;margin-bottom: 10px;" v-if="intentItems.length > 1">
                        <div class="col-xs-10" >
                            <div style="padding: 10px;">

                                Alternative {{mindex + 1}}
                            </div>
                        </div>
                        <div class="col-xs-2 text-right" style="padding: 0 10px">
                             <a href="javascript:void(0);" class="btn" @click="deleteAlternativeMessage(mindex)" ><span class="fas fa-remove"></span></a>
                        </div>
                    </div>
                    <li style="list-style-type: nonex" v-for="(item,index) in messages" :key="'intent_item_'+ index">                
                        <template>
                                <move-vertical :index="index" :max="messages.length" @onMove="onMove(mindex,index,$event)" style="width: 20px;min-width: 20px;display: inline-block;float: left;margin-right: 10px;"></move-vertical>
                                <template v-if="item.type == 'text'">   
                                    <div class="message" style="float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;" >
                                        <div style="font-size: 12px;color:black">
                                            <template >
                                                <div style="padding: 5px 8px 6px;background-color:#F1F0F0" >
                                                    <div :class="{'has-error' : errors.has('answer_'+mindex+'_text_'+ index)}">
                                                        <autoresize-textarea maxlength="640" :ref="'answer_'+mindex" class="form-control" placeholder="Answer" v-model="item.value.text"  name="answer" data-vv-as="Answer" :data-vv-name="'answer_'+mindex+'_text_'+ index" v-validate="'required'" style="resize: none" @keyup.native="onTyping"></autoresize-textarea>
                                                        <!-- <textarea ref="answer" class="form-control" placeholder="Answer" @keyup="resizeTextarea(index)" v-model="item.value"  name="answer" data-vv-as="Answer" v-validate="'required'" style="resize: none" @keydown="onTyping"></textarea> -->
                                                        <span class="text-error" v-show="errors.has('answer_'+mindex+'_text_'+ index)">
                                                            {{errors.first('answer_'+mindex+'_text_'+ index)}}
                                                        </span>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-xs-12 text-left" style="margin-top: 10px;">
                                                            <!-- <a href="javascript:void(0);" @click="showEmoji = !showEmoji; currentIndex = index"><img src="/static/img/assets/facebook_ui/Expression.png" alt=""></a> -->
                                                            <intent-prefill @addIntentPrefill="addIntentPrefill(mindex,index,$event)"></intent-prefill>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>

                                        <div class="clearfix"></div>
                                        <div style="float:left;width: 100%;border: 1px solid #eee; overflow: hidden;border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;">
                                            <ul class="list-group list-group-flush"  style="margin-bottom: 0px;">
                                                <template v-if="item.value.buttons && item.value.buttons.length > 0">
                                                    <li class="list-group-item" style="border-left:none;border-right:none;border-bottom:none; border-radius: 0px;text-align: center;padding: 5px 10px" :style="{'border-top': bindex != 0 ? '1px solid #eee' : 'none'}" v-for="(button,bindex) in item.value.buttons" :key="bindex">
                                                        <span style="overflow: auto;position: relative">
                                                            <span style="color: #0084FF;" :title="button.title">{{ button.title | truncate(12) }}</span>
                                                            <div style="position: absolute;right: -45px;top: 0px;">
                                                                <add-generic-button v-model="item.value.buttons[bindex]" @onSave="editButton(mindex, index, bindex, $event)"><span class="glyphicon glyphicon-pencil"></span></add-generic-button> 
                                                                <a href="javascript:void(0);" @click="deleteButton(mindex,index, bindex)" style="margin-left: 5px;"><span class="glyphicon glyphicon-trash"></span></a>
                                                            </div>
                                                            <div class="clearfix"></div>

                                                            <div style="margin: 0;font-size: 10px;">
                                                                <span v-if="button.type == 'web_url'" :title="button.url">{{button.url | truncate(20)}}</span>
                                                                <span v-else-if="button.type == 'postback'" :title="button.payload">{{button.payload | truncate(20)}}</span>
                                                                <span v-else-if="button.type == 'phone_number'" :title="button.payload">{{button.payload | truncate(20)}}</span>
                                                                <span v-else>&nbsp;</span>
                                                            </div> 
                                                        </span>
                                                    </li>
                                                </template>
                                                <li v-if="item.value.buttons && item.value.buttons.length < 3" class="list-group-item" style="border-left:none;border-right:none;border-bottom:none;border-radius: 0px;text-align: center" :style="{'border-top': item.value.buttons.length != 0 ? '1px solid #eee' : 'none'}"><add-generic-button v-model="newButton" @onSave="addNewButton(mindex,index,$event)"><span class="glyphicon glyphicon-plus"></span> Add button</add-generic-button></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <a href="javascript:void(0);" v-if="messages && messages.length > 1" @click="onDelete(mindex,index)" style="float:left;padding: 5px" >
                                        <span class="glyphicon glyphicon-trash" ></span>
                                    </a>
                                </template>
                                <template v-else-if="item.type == 'image'">
                                    <div :ref="'answer_'+mindex" class="message" style="float:left;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;">
                                        
                                        <uploadfile ref="answer" v-model="item.value" :height="181" @onUploaded="updateIntent" data-vv-as="Image" :data-vv-name="'answer_'+mindex+'_image_'+ index" v-validate="'required'"></uploadfile>
                                        
                                    </div>
                                    <a href="javascript:void(0);" v-if="messages && messages.length > 1" @click="onDelete(mindex,index)" style="float:left;padding: 5px" >
                                    <span class="glyphicon glyphicon-trash" ></span>
                                    </a>
                                    <div class="clearfix"></div>
                                </template>
                                <div class="clearfix"></div>
                                <div class="has-error" style="margin-left: 30px">
                                    <span class="text-error" v-show="errors.has('answer_'+mindex+'_image_'+ index)">
                                        {{errors.first('answer_'+mindex+'_image_'+ index)}}
                                    </span>
                                </div>
                                <div style="margin-bottom: 10px;"></div>

                        </template>
                    </li>

                    
                    <li style="list-style-type: none;padding: 15px;" v-if="messages.length < 5"> 
                        <a href="javascript:void(0);" class="btn-add-intent" @click="addIntentItem('text',mindex)">
                            <span class="glyphicon glyphicon-comment"></span> 
                            <p>Add Text</p>
                        </a>

                        <a href="javascript:void(0);" class="btn-add-intent" @click="addIntentItem('image',mindex)">
                            <span class="glyphicon glyphicon-picture"></span> 
                            <p>Add Image</p>
                        </a>
                    </li>
                </ul>
            </div>
            <div style="flex-grow: 1;vertical-align: top;min-width: 300px;max-width: 300px;padding: 15px;border: 3px dashed #eee; margin-left: 10px;border-radius: 30px;position: relative;margin-bottom: 25px" @click="addAlternativeMessnage" v-if="hasAlternative">
                <div style="position:absolute;left: 50%;top: 50%;margin-left: -10px;margin-top: -23px;font-size: 32px;">
                    <span class="glyphicon glyphicon-plus"></span>
                </div>
            </div>
        </div>
    </dir>
</template>

<script>
import IntentText from './IntentText'
import draggable from 'vuedraggable'
import IntentPrefill from './IntentPrefill'
import { Picker } from 'emoji-mart-vue'
import ModalDialog from '@/components/elements/ModalDialog'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'
import MoveVertical from '@/components/elements/MoveVertical'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import AddGenericButton from '@/components/view/chatbot/AddGenericButton'

    export default {
        props: {
            'value' : {
                default: ''
            },
            'hasAlternative' : {
                default: true,
                type: Boolean
            }
        },
        inject: ['$validator'],
        data: function(){
            return {
                group: '',
                intentItems: [],
                showEmoji: false,
                typingTimer: null,
                currentIndex: null,
                newButton: {
                    title: '',
                    type: 'web_url',
                    url: '',
                }
            }
        },
        components: {
            IntentText,
            draggable,
			IntentPrefill,
            Picker,
            ModalDialog,
            specialtext,
            uploadfile,
            MoveVertical,
            AutoresizeTextarea,
            AddGenericButton
        },
        created: function(){
            var vm = this
            vm.group = vm.value


            if (vm.group != '') {
                var newGroup = []
                var group = vm.group.split("||");
                $.each(group,function(index, messages){
                    var newMessage = []
                    var group_messages = messages.split("#nl");
                    $.each(group_messages,function(index, message){
                        var type = 'text'
                        if (!isNaN(message)) {
                            newMessage.push({
                                type: 'text',
                                value: {
                                    text: message,
                                    buttons: []
                                }
                            })
                        } else if (vm.isJsonParseable(message)) {
                            newMessage.push({
                                type: 'text',
                                value: JSON.parse(message)
                            })
                        } else if(vm.isURL(message)){
                            newMessage.push({
                                type: 'image',
                                value: message
                            })
                        } else {
                            newMessage.push({
                                type: 'text',
                                value: {
                                    text: message,
                                    buttons: []
                                }
                            })
                        }
                        
                    })
                    newGroup.push(newMessage)
                })

                vm.intentItems = newGroup
            } else {
                vm.intentItems = [
                    [
                        {
                            value: {
                                text: '',
                                buttons: []
                            },
                            type: 'text'
                        }
                    ]
                ];
            }
        },
        computed: {
        },
        methods: {
            addAlternativeMessnage: function(){
                this.intentItems.push([
                        {
                            value: {
                                text: '',
                                buttons: []
                            },
                            type: 'text'
                        }
                    ])
                    this.updateIntent()
            },
            deleteAlternativeMessage: function(index){
                if (confirm('Do you want to delete this alternative message?')) {
                    this.intentItems.splice(index,1)
                    this.updateIntent()
                }
            },
            addIntentPrefill: function(index,subindex,prefill){
                var vm = this
                    let cursorPosition = this.$refs['answer_'+index][subindex].$el.selectionStart
                    if (vm.intentItems[index][subindex].type == 'text') {
                        vm.$set(vm.intentItems[index][subindex].value,'text',[vm.intentItems[index][subindex].value.text.slice(0, cursorPosition), '{' + prefill + '}' , vm.intentItems[index][subindex].value.text.slice(cursorPosition)].join(''))
                    } else {
                        // vm.$set(vm.intentItems[index][subindex],'value',[vm.intentItems[index][subindex].value.slice(0, cursorPosition), '{' + prefill + '}' , vm.intentItems[index][subindex].value.slice(cursorPosition)].join(''))
                    }
                    vm.updateIntent()
                
			},
			addEmoji: function(emoji){
                var vm = this
                let cursorPosition = this.$refs.answer[this.currentIndex].$el.selectionStart
                if (vm.intentItems[this.currentIndex].type == 'text') {
                    vm.$set(vm.intentItems[this.currentIndex].value,'text',[vm.intentItems[this.currentIndex].value.text.slice(0, cursorPosition), emoji.native , vm.intentItems[this.currentIndex].value.text.slice(cursorPosition)].join(''))
                } else {
                    // vm.$set(vm.intentItems[this.currentIndex],'value',[vm.intentItems[this.currentIndex].value.slice(0, cursorPosition), emoji.native , vm.intentItems[this.currentIndex].value.slice(cursorPosition)].join(''))
                }
                vm.showEmoji = false
                vm.updateIntent()
            },
            addIntentItem: function (type,index) {
                if (type == 'text') {
                    this.intentItems[index].push({
                        value: {
                            text: '',
                            buttons: []
                        },
                        type: type
                    });
                } else {
                    this.intentItems[index].push({
                        value: '',
                        type: type
                    });

                }
                this.updateIntent()
            },
            onDelete: function(index,subindex){
                this.intentItems[index].splice(subindex,1)
                this.updateIntent()
            },
            isURL: function(str) {
                var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name and extension
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                '(\\:\\d+)?'+ // port
                '(\\/[-a-z\\d%@_.~+&:]*)*'+ // path
                '(\\?[;&a-z\\d%@_.,~+&:=-{}()]*)?'+ // query string
                '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
                return pattern.test(str);
            },
            isJsonParseable: function(str){
                try {
					JSON.parse(str);
				} catch (e) {
					return false;
				}
				return true
            },
            isNumber: function(str) {
                try {
					parseFloat(str);
				} catch (e) {
					return false;
				}
				return true
            },
            onMove: function(index, subindex, direction){
                var vm = this
                if (direction == 'up') {
                    vm.intentItems[index].splice(subindex, 0, vm.intentItems[index].splice(subindex-1, 1)[0]);
                } else if(direction == 'down') {
                    vm.intentItems[index].splice(subindex, 0, vm.intentItems[index].splice(subindex+1, 1)[0]);
                }
                this.updateIntent()
            },
            onTyping: function(){
                // clearTimeout(this.typingTimer); 
                // this.typingTimer = setTimeout(this.updateIntent(), 1000)
                this.updateIntent()
            },
            updateIntent: function(){
                let vm = this 
                var group = []
                new Promise((resolve, reject) => {
                    $.each(vm.intentItems,function(index,messages){
                        var result = []
                        $.each(messages,function(mindex, message){
                            if (message.type == 'text') {
                                if (message.value.buttons && message.value.buttons.length > 0) {
                                    if (message.value.text != '') {
                                        // result.push(message.value.text)
                                        result.push(JSON.stringify(message.value))
                                    }
                                } else {
                                    if (message.value.text != '') {
                                        result.push(message.value.text)
                                    }
                                }
                            } else {
                                result.push(message.value)   
                            }
                        })
                        group.push(result.join('#nl'))
                    })
                    var intent = group.join('||')
                    vm.group = intent
                    resolve()
                })
            },
            addNewButton: function(index,subindex, payload){
                if (this.intentItems[index][subindex].value.buttons.length < 3) {
				
                    if (payload.type == 'web_url') {
                        delete payload.payload
                    } else if(payload.type == 'postback' || payload.type == 'phone_number'){
                        delete payload.url
                    }
                    this.intentItems[index][subindex].value.buttons.push(payload)
                    this.newButton = {
                        title: '',
                        type: 'web_url',
                        url: ''
                    }
                    this.updateIntent()
                }
            },
            editButton: function(index,subindex, bindex, payload){
                if (this.intentItems[index][subindex].value.buttons[bindex]) {
                    // this.intentItems[index].value.buttons[index] = payload
                    if (payload.type == 'web_url') {
                        delete payload.payload
                    } else if(payload.type == 'postback' || payload.type == 'phone_number'){
                        delete payload.url
                    }
                    this.$set(this.intentItems[index][subindex].value.buttons, bindex , payload)
                    this.updateIntent()
                }
            },
            deleteButton: function(index,subindex, bindex){
                // if (this.intentItems.length >= 1) {
                //     return false
                // }
                this.intentItems[index][subindex].value.buttons.splice(bindex,1)
                this.updateIntent()
            },
        },
        watch: {
            group: function(){
               this.$emit('input',this.group) 
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/intent/IntentGroup.vue